// there are 3 components to take care of staff card in profile page
// 1.below is component to do saving and extracting of staff info including local storage and db calls.

import StaffComponent from "./StaffComponent";

//Parent component = MyProfilePage
export default function StaffRegister() {
  return (
    <div>
      <StaffComponent />
    </div>
  );
}
